module.exports = __webpack_public_path__ + "static/dalycity-e4f1350784790365d4a8185eff1b676a.jpg";